<script>
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import axios from "axios";
import Swal from "sweetalert2";
import MultiSelect from 'primevue/multiselect';

export default {
  name: 'BulkSms',
  components: {
    Dialog,
    Dropdown,
    MultiSelect
  },
  props: {
    academic_year_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      formSending: false,
      attendance_message: "",
      reservations: [],
      students: [],
      status: null,
      status_list: [
        {
          id: 0,
          title: "معلق",
        },
        {
          id: 1,
          title: "مقبول",
        },
        {
          id: 2,
          title: "مرفوض",
        },
        {
          id: 3,
          title: "في انتظار الشهادة",
        }
      ],
    };
  },
  computed: {
    smsCount() {
      return Math.ceil(this.attendance_message.length / 70) || 1;
    }
  },
  methods: {
    openDialog() {
      this.visible = true;
    },
    fetchReservation(page = 1) {
      const formData = new FormData();
      if (this.academic_year_id) formData.append('academic_year_id', this.academic_year_id);

      if (this.status) {
        formData.append('status', this.status.id);
      }

      axios.defaults.headers.common["per_page"] = 10000000;
      axios
          .post(`/all_reservations?page=${page}`, formData)
          .then((response) => {
            this.reservations = response.data.data.data;
            this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.reservations = {};
          });
    },


    async SendAttendanceMessage() {
      this.formSending = true;

      const studentPhones = this.students.map(item => '2' + item.student_phone);

      // ── 1. فحص WhatsApp لكل الأرقام دفعة واحدة (مع cache داخلي في Backend) ──
      let whatsappStatuses = {};
      try {
        const checkRes = await axios.post('/whatsapp/check-bulk', { phones: studentPhones });
        whatsappStatuses = checkRes.data.results ?? {};
      } catch {
        // فشل الفحص → يُرسَل الكل بـ SMS
      }

      // ── 2. تصنيف الأرقام ──
      const whatsappPhones = studentPhones.filter(p => whatsappStatuses[p] === true);
      const smsPhones      = studentPhones.filter(p => whatsappStatuses[p] !== true);

      // ── 3. إرسال WhatsApp ──
      for (const phone of whatsappPhones) {
        try {
          const sendRes = await axios.post('/whatsapp/send', {
            phone,
            message: this.attendance_message,
          });
          if (!sendRes.data.success) {
            smsPhones.push(phone); // fallback إلى SMS إذا فشل الإرسال
          }
        } catch {
          smsPhones.push(phone); // fallback عند أي خطأ
        }
      }

      // ── 4. SMS الحالي للأرقام المتبقية (كود SMS بدون أي تعديل) ──
      if (smsPhones.length > 0) {
        const payload = {
          SenderName: "SMS invite",
          RequestID: this.status.id,
          PhoneNumbers: smsPhones,
          Message: this.attendance_message
        };

        const savedAuth = axios.defaults.headers.common["Authorization"];
        axios.defaults.headers.common["Authorization"] = '667d0a1e-f2b3-4bd5-8569-360b6e7b80b0';
        axios.defaults.headers.common["Content-Type"] = 'application/json';

        await axios
            .post(`https://hubapi.advansystelecom.com/api/bulkSMS/ForwardBulkSMS`, payload)
            .then((response) => {
              const result = response.data;
              if (result === "1") {
                Swal.fire({
                  icon: 'success',
                  title: 'تم الإرسال',
                  text: 'تم إرسال الرسالة بنجاح',
                  timer: 1500,
                  showConfirmButton: false
                });
              }
            })
            .catch((error) => {
              const result = error.response?.data?.Message;
              const messages = {
                '-1': 'رمز التوثيق غير صحيح',
                '-2': 'رقم الجوال فارغ',
                '-3': 'نص الرسالة فارغ',
                '-4': 'اسم المرسل غير صحيح',
                '-5': 'لا يوجد رصيد كافٍ',
              };
              Swal.fire({
                icon: 'error',
                title: 'خطأ',
                text: messages[result] ?? 'حدث خطأ غير متوقع',
                timer: 3000,
                showConfirmButton: false
              });
            });

        axios.defaults.headers.common["Authorization"] = savedAuth;
      } else if (whatsappPhones.length > 0) {
        // تم الإرسال بالكامل عبر WhatsApp
        Swal.fire({
          icon: 'success',
          title: 'تم الإرسال',
          text: 'تم إرسال الرسائل عبر واتساب بنجاح',
          timer: 1500,
          showConfirmButton: false
        });
      }

      this.formSending = false;
    }
  }
};
</script>

<template>
  <button class="btn PrimaryButton" type="button" @click="openDialog">رسائل جماعية</button>


  <Dialog v-model:visible="visible" modal header="رسائل جماعية" :style="{ width: '35rem' }">
    <div class="row">
      <div class="col-12">
        <div class="form-group d-flex flex-column">
          <label for="status">حالة الحجز</label>
          <Dropdown v-model="status" :options="status_list" showClear optionLabel="title"
                    placeholder="حالة الحجز" @change="fetchReservation" />
        </div>
      </div>
      <div class="col-12 mt-3" v-if="reservations">
        <div class="form-group d-flex flex-column">
          <label for="status">الطلاب</label>
          <MultiSelect v-model="students" :options="reservations" optionLabel="name" filter placeholder="الطلاب"
                       :maxSelectedLabels="3" class="w-full md:w-100" />

        </div>
      </div>
      <div class="col-12 mt-3">
        <textarea class="form-control" rows="5" v-model="attendance_message" placeholder="اكتب الرسالة هنا"></textarea>
        <div class="text-end mt-1" :class="attendance_message.length > 70 ? 'text-danger' : 'text-success'">
          {{ attendance_message.length }} حرف
          <span class="ms-2">عدد الرسائل: {{ smsCount }}</span>
        </div>
<!--        <span :class="attendanceMessageLength > 70 ? 'text-danger' : 'text-success'">{{ attendanceMessageLength }}</span>-->
      </div>
      <div class="col-12 mt-4">
        <button class="PrimaryButton w-100" type="button" :disabled="formSending" @click="SendAttendanceMessage"><i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i> {{ formSending ? 'جاري الارسال...' : 'إرسال' }} </button>
      </div>
    </div>
  </Dialog>

</template>

<style scoped>

</style>